import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';

interface LicenseAssignmentStatusProps {
  assigned?: boolean;
}

const LicenseAssignmentStatus = ({ assigned = false }: LicenseAssignmentStatusProps) => {
  const { t } = useTranslation('AssignmentStatus');
  const classes = useStyles();

  return assigned ? (
    <Typography variant="subtitle1" className={classes.assignedText}>
      <CheckCircle className={classes.assignedIcon} /> {t('Assigned')}
    </Typography>
  ) : (
    <Typography variant="subtitle1" className={classes.unassignedText}>
      {t('Unassigned')}
    </Typography>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  assignedText: {
    color: theme.palette.success.dark
  },
  assignedIcon: {
    bottom: theme.typography.pxToRem(-4),
    fill: theme.palette.success.dark,
    fontSize: theme.typography.pxToRem(18),
    position: 'relative'
  },
  unassignedText: {
    color: '#696969'
  }
}));

export default LicenseAssignmentStatus;
